<!--
 * @Author: chenhongwei chenhw2019@gmail.com
 * @Date: 2023-04-26 20:18:51
 * @LastEditors: chenhongwei chenhw2019@gmail.com
 * @LastEditTime: 2023-05-25 11:28:07
 * @FilePath: /桌面工作区/seller.sviptrader.com/src/components/categorySelect/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="category-wrapper">
		<el-cascader
			v-model="selectedList"
			separator="-"
			ref="category"
			style="width: 240px"
			:placeholder="placeholder"
			:collapse-tags="true"
			:options="categoryList"
			:props="selProps"
			clearable
			filterable
			:size="size"
		></el-cascader>
	</div>
</template>
<script>
import { getCategoryList } from '@/api/shopManage';
export default {
	data() {
		return {
			categoryList: [],
			options: [],
			selProps: {
				// 改为传入multiple
				multiple: true,
				value: 'category_id',
				label: 'category_name',
				children: 'son',
				emitPath: false,
			},
		};
	},
	computed: {
		selectedList: {
			get() {
				return this.value;
			},
			set(checked) {
				this.$emit('input', checked);
			},
		},
	},
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		platformId: {
			type: [String, Number],
			default: dataMap.PLATFORM_DY.value,
		},
		size: {
			type: String,
			default: 'mini',
		},
		multiple: {
			type: Boolean,
			default: true,
		},
		placeholder: {
			type: String,
			default: '全部类目',
		},
	},
	watch: {
		platformId() {
			this.initCategoryList();
		},
		multiple: {
			handler(val) {
				this.selProps.multiple = val;
			},
			immediate: true,
		},
	},
	mounted() {
		this.initCategoryList();
	},
	methods: {
		async initCategoryList() {
			try {
				const { data, code } = await getCategoryList({
					platform_id: this.platformId,
				});
				if (code !== 0) return;
				this.categoryList = data;
			} catch (error) {
				this.categoryList = [];
			}
		},
	},
};
</script>
<style lang="less" scoped>
.category-wrapper {
	display: inline-block;
}
.category-wrapper /deep/ .el-cascader {
	.el-cascader__search-input {
		background-color: white !important;
		margin: 2px 0 2px 10px;
		max-width: 90px;
	}
	.el-input__inner {
		height: 32px !important;
		box-sizing: border-box;
	}
	.el-tag {
		& > span {
			max-width: 40px;
		}
	}
	input {
		background: inherit;
		// margin: 2px 0 2px 15px;
	}
	::placeholder {
		color: #919ba7;
	}
}
/deep/ .el-cascader__tags .el-tag {
	margin-top: 4px;
}
</style>
